import { useGetWorkspacePreferences } from '~/hooks/users/useGetWorkspacePreferences'
import { SALE_EVENTS } from '../constants/saleEvents'
import { usePlanProducts } from './usePlanProducts'
import { useSuspenseQuery } from '~/services'
import { useActiveSubscription } from './useActiveSubscription'
import { useCurrentUser } from '~/hooks'

export const useSaleEvent = (workspaceId: string) => {
  const { data: cancelledToCommunity } = useGetWorkspacePreferences({ path: 'cancelledToCommunity' }, workspaceId)
  const { nextPhasePlan } = usePlanProducts(workspaceId)
  const currentUser = useCurrentUser()
  const { yearly: yearlyActiveSubscription } = useActiveSubscription(workspaceId)

  const {
    data: { billingVersion },
  } = useSuspenseQuery('workspaces_/$workspaceId_', { workspaceId })

  const cancellationDate =
    cancelledToCommunity?.date ||
    (yearlyActiveSubscription?.canceled_at ? new Date(yearlyActiveSubscription.canceled_at * 1000) : undefined)

  const saleEvent = SALE_EVENTS.find((event) => {
    const now = new Date()
    return now >= event.startDate && now <= event.endDate
  })

  const elligibleForDiscount =
    saleEvent &&
    saleEvent.isElligible({
      nextPhasePlan: nextPhasePlan.legacyName,
      cancelWindowStart: saleEvent.startDate,
      cancelWindowEnd: saleEvent.endDate,
      cancellationDate,
      billingVersion,
      userEmail: currentUser.email,
    })

  return elligibleForDiscount ? saleEvent : null
}
